import { Header } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

const SectionHeading = Header.withConfig({
  variant: 'headerTwo',
  color: primitive.$bbqBrown,
  fontSize: 'xl',
  marginTop: '$5',
  marginBottom: '$3',
  focusable: true,
});

export default SectionHeading;
